import { Modal } from 'm-ui';
import axios from 'axios';
import { UserInfo } from 'models/ad-user/interface';
import { addFMP } from '@/utils/businesslog';

export async function getUserInfo(redirectUrl) {
    const params = redirectUrl ? { redirectUrl } : undefined;
    const { user, ...others } = await axios.post<any, UserInfo>('/rest/dsp/owner/info', params);

    addFMP();
    if (others.wanxiangHomePageWhiteList === false) {
        Modal.warning({
            title: '您当前账户未开通万象2.0权限，即将前往原版本！',
            width: '450px',
            className: 'home-permission',
            onOk() {
                window.location.href = 'http://dmp.e.kuaishou.com';
            },
        });
        return;
    }

    const { agentUserId, adminUserId } = others;
    user.userId = user.user_id;
    user.userName = user.user_name;
    user.headUrl = user.headurl;
    const isCRMLogin = !!agentUserId || !!adminUserId;

    localStorage.setItem('secondIndustryName', others?.secondIndustryName);

    // 曝光页面埋点中需要上报该参数，标识账户类型
    localStorage.setItem('appId', others?.appId.toString());

    return {
        user,
        ...others,
        isCRMLogin,
        isKa: others.appId === 4,
        kaAccountUcId: others.accountUcId,
        accountUcId: others.userDspAccount.accountUcId,
    };
}

export async function getLoginInfo() {
    const data = await axios.post<any, any>('/rest/dmp/login/info');
    return data;
}

export async function getAccountAppId(accountId: number) {
    const data = await axios.post<any, any>('/rest/dmp/login/account/appId', { accountId });
    return data;
}

export interface AccountInfoItem {
    accountId: number;
    accountName: string;
    appId: string;
    createTime: number;
    lastLoginTime: number;
}

export async function getAccountList() {
    const data = await axios.post<
        any,
        {
            accountInfoList: AccountInfoItem[];
        }
    >('/rest/dmp/login/accountInfoList');
    return data.accountInfoList;
}

export async function postFeedback(params: { name: string; phoneNo: string; description: string }) {
    if (
        params &&
        Object.prototype.toString.call(params) === '[object Object]' &&
        Object.keys(params).length
    ) {
        const { result } = await axios.post<any, any>('/rest/dmp/home/feedback', params);
        return result === 1;
    }
}

export async function login({ authToken, sid }) {
    const res = await axios.post<any, any>(`/rest/infra/sts?authToken=${authToken}&sid=${sid}`);
    return res;
}

export const getJuxingAccountList = async () => {
    const data = await axios.post<
        any,
        {
            accountInfoList: AccountInfoItem[];
        }
    >('/rest/dmp/juxingAccountInfoList');
    return data.accountInfoList;
};
